import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ReactNotifications } from 'react-notifications-component';
import React, { useState } from "react";
import { ClienteContext, LastPositionContext } from "./components/services/ClienteContext";
import 'animate.css';
import 'react-notifications-component/dist/theme.css';

import UserLogin from "./components/Views/Login/UserLogin";
import Home from "./components/Views/Home/Home";
import Header from "./components/Views/Header/Header"
import Mapa from "./components/Views/Mapa/Mapa";
import LastPosition from "./components/Views/LastPosition/LastPosition";
import ReportsPositions from "./components/Views/Reports/Positions/ReportPage";
import ReportsPositionsPerc from "./components/Views/Reports/Percurso/ReportPagePerc";
import RecPass from "./components/Views/RecPass/Index";


import SisLogin from "./components/Views/Login/SisLogin";
import HeaderSistem from "./components/Views/Header/HeaderSistem"
import HomeSis from "./components/Views/Home/Sistema/HomeSis"
import ChipManager from "./components/Views/Sistema/Cadastro/ChipManager/ChipManager.jsx"
import OperatorManager from "./components/Views/Sistema/Cadastro/OperatorManager/OperatorManager.jsx"
import ClientManager from "./components/Views/Sistema/Cadastro/ClientManager/ClientManager.jsx"
import EquipManager from "./components/Views/Sistema/Cadastro/EquipManager/EquipManager.jsx"
import VehiclesManager from "./components/Views/Sistema/Cadastro/VehiclesManager/VehiclesManager.jsx"
import Acompanhamento from "./components/Views/Sistema/Assets/Acompanhamento/Acompanhamento.jsx"
import { LoadingProvider } from "./components/services/LoadingContext.jsx";

const App = () => {

  const [dados, setDados] = useState({})
  const [posiData, setLastPosiData] = useState({})

  return (
    <ClienteContext.Provider value={{ dados, setDados }}>
      <LastPositionContext.Provider value={{ posiData, setLastPosiData }}>
        <Router basename="/portal">
          <ReactNotifications id='notification' />
          <LoadingProvider/>
          <Routes >
            <Route path="/" element={<UserLogin />} />
            <Route path="/login" element={<UserLogin />} />
            <Route path="/escpass" element={<RecPass />} />
            <Route path="/mapa" element={<><Header dados={dados} /><Mapa /></>} />
            <Route path="/home" element={<><Header dados={dados} /><Home /></>} />
            <Route path="/lastPosi" element={<><Header dados={posiData} /><LastPosition /></>} />
            <Route path="/positionsperc" element={<><Header dados={posiData} /><ReportsPositionsPerc /></>} />
            <Route path="/positions" element={<><Header dados={posiData} /><ReportsPositions /></>} />

            {/* SISTEMA */}

            <Route path="/sistema" element={<SisLogin />} />
            <Route path="/gestoria" element={<><HeaderSistem dados={dados} /><HomeSis /></>} />
            <Route path="/chipmanager" element={<><HeaderSistem dados={dados} /><ChipManager /></>} />
            <Route path="/apnmanager" element={<><HeaderSistem dados={dados} /><OperatorManager /></>} />
            <Route path="/clientmanager" element={<><HeaderSistem dados={dados} /><ClientManager /></>} />
            <Route path="/equipmanager" element={<><HeaderSistem dados={dados} /><EquipManager /></>} />
            <Route path="/vehiclesmanager" element={<><HeaderSistem dados={dados} /><VehiclesManager /></>} />
            <Route path="/acompanhe/:id" element={<Acompanhamento />} />


          </Routes>
        </Router>
      </LastPositionContext.Provider>
    </ClienteContext.Provider>
  );
}

export default App;
